"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Alert = _interopRequireDefault(require("./Alert.style"));

var alertClassNames = {
  primary: 'theme--color-accent',
  success: 'theme--color-green',
  error: 'theme--color-red',
  warning: null
};

var Alert = function Alert(_ref) {
  var type = _ref.type,
      text = _ref.text;
  return _react.default.createElement(_Alert.default, {
    className: (0, _classnames.default)('alert', alertClassNames[type]),
    type: type
  }, _react.default.createElement(_Icon.default, {
    type: "alert"
  }), text);
};

Alert.defaultProps = {
  type: '',
  text: ''
};
Alert.propTypes = {
  type: _propTypes.default.string,
  text: _propTypes.default.string
};
var _default = Alert;
exports.default = _default;